import React from 'react';

import ContentLoader from 'react-content-loader';

type ContentLoaderProps = {
  loading: boolean;
  children?: React.ReactNode;
  height: number;
  width?: number;
  rows?: number;
  rowHeight?: number;
  rowSpacing?: number;
};

export const Skeleton: React.FC<ContentLoaderProps> = ({
  loading: isLoading,
  height,
  width = 170,
  rows = 1,
  rowHeight = 15,
  rowSpacing = 20,
  children,
}) => {
  const totalHeight = rows > 1 ? (rows - 1) * rowSpacing + rowHeight : height;

  return (
    <>
      {isLoading ? (
        <ContentLoader height={totalHeight}>
          {Array.from({ length: rows }).map((_, index) => (
            <rect
              key={index}
              x="0"
              y={index * rowSpacing}
              width={width}
              height={rowHeight}
            />
          ))}
        </ContentLoader>
      ) : (
        children
      )}
    </>
  );
};
